import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SolutionsBlockData from '../../../Models/Content/SolutionsBlockData';
import MainSolutions from './MainSolutions';

export default class SolutionsBlock extends EpiComponent<SolutionsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainSolutions iContent={this.props.data} context={this.getContext()} />;
  }
}
